export default __webpack_public_path__ + "static/media/logo-dark.e6d6ba74.png";